import {Money} from "../redux/types";

export const formatMoney = (money: Money | undefined | null): string => {

  if (money === null || money === undefined) {
    return '-'
  }

  return `${money.amount.toLocaleString('sv-SE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })} ${money.currencyCode?.toUpperCase() ?? 'MISSING CURRENCY CODE'}`
}

export const addMoney = (a: Money | undefined | null, b: Money | undefined | null) : Money | undefined => {
  if (a === null || a === undefined || b === null || b === undefined) {
    return undefined
  }

  if (a.currencyCode !== b.currencyCode) {
    return undefined
  }

  return {
    amount: a.amount + b.amount,
    currencyCode: a.currencyCode
  }
}

export const subtractMoney = (a: Money | undefined | null, b: Money | undefined | null) : Money | undefined => {
  if (a === null || a === undefined || b === null || b === undefined) {
    return undefined
  }

  if (a.currencyCode !== b.currencyCode) {
    return undefined
  }

  return {
    amount: a.amount - b.amount,
    currencyCode: a.currencyCode
  }
}
